<template>
  <div class="driver-manage">
    <div class="manage-query">
      <el-form
        :inline="true"
        :model="query"
        ref="queryForm"
        :rules="queryRules"
        size="small"
        class="query-middle"
      >
        <el-form-item label="司机姓名：" prop="tickeId">
          <el-input v-model="query.name"></el-input>
        </el-form-item>
        <el-form-item label="创建时间：" prop="StartTime" style="margin-left:20px;">
          <el-date-picker v-model="query.StartTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" style="width: 200px"></el-date-picker>
        </el-form-item>
        <el-form-item label="—" prop="EndTime">
          <el-date-picker v-model="query.EndTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" style="width: 200px"></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left:20px;">
          <el-button type="primary" icon="el-icon-search" @click="loadDriverList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" icon="el-icon-circle-close" @click="clearQuery('queryForm')">清除</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="manage-content">
      <div class="main-left">
        <div class="main-title">
          <span>
            <i class="el-icon-folder-opened"></i>司机列表
          </span>
          <el-button-group>
            <el-button icon="el-icon-circle-plus-outline" type="primary" size="mini" @click="add">新增</el-button>
          </el-button-group>
        </div>
        <div>
          <el-dialog
            title="添加司机"
            :visible.sync="adddialogVisible"
            :close-on-click-modal="false"
            width="30%"
            @closed="closeDialog('postForm')"
          >
            <el-form
              :model="addForm"
              status-icon
              :rules="addformrules"
              ref="postForm"
              label-width="70px"
            >
              <el-form-item label="姓名" prop="name">
                <el-input v-model="addForm.name"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-select v-model="addForm.Sex" placeholder="请选择">
                  <el-option
                    v-for="item in genderMap"
                    :key="item.key"
                    :label="item.val"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="电话" prop="tel">
                <el-input v-model="addForm.tel"></el-input>
              </el-form-item>
              <el-form-item label="身份证" prop="IdNumber">
                <el-input v-model="addForm.IdNumber"></el-input>
              </el-form-item>
              <el-form-item label="照片">
                <el-upload
                  v-if="adddialogVisible"
                  ref="uploadAdd"
                  action="/api/co/Attachment/UploadAttachment"
                  :before-upload="uploadBefore"
                  :on-success="uploadSuccessAdd"
                  :on-remove="uploadRemoveAdd"
                  :on-error="uploadError"
                  list-type="picture"
                  :limit="1"
                  :headers="{
            AttachmentType:'scenic-pic',
              sessionId: voucher.sessionId,
              'X-Token':voucher.token,
             }"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip">只能上传图片文件，且不超过10MB,数量为1</div>
                </el-upload>
              </el-form-item>
            </el-form>
            <span slot="footer">
              <el-button @click="adddialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="postModel('postForm')">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <div class="left-table">
          <el-table
            :data="tableData"
            row-key="id"
            v-loading="loadintTable"
            height="753px"
            :default-sort="{prop: 'ApplyTime', order: 'descending'}"
            border
            style="width:100%"
          >
            <el-table-column type="selection" min-width="10" align="center"></el-table-column>
            <el-table-column label="姓名" prop="Name" min-width="120" align="center"></el-table-column>
            <el-table-column label="性别" prop="Sex" min-width="60" align="center"></el-table-column>
            <el-table-column label="电话" prop="Tel" min-width="120" align="center"></el-table-column>
            <el-table-column label="创建时间" prop="ApplyTime" min-width="180" align="center">
              <template slot-scope="scope">
                <p>{{scope.row.ApplyTime | dateFormat}}</p>
              </template>
            </el-table-column>
            <el-table-column label="状态" prop="Status" min-width="100" align="center"  fixed="right">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.Status | statusTypeFormat(normalStatus)"
                  effect="dark"
                  size="small"
                >{{scope.row.Status | status2Format(normalStatus)}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="200" align="center" fixed="right">
              <template slot-scope="scope">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-button-group>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="lookDriver(scope.row.Id)"
                    >查看</el-button>
                    <el-button
                      size="mini"
                      type="warning"
                      @click="changeDrive(scope.row.Id,1)"
                      v-if="scope.row.Status === 0"
                    >禁用</el-button>
                    <el-button
                      size="mini"
                      type="warning"
                      @click="changeDrive(scope.row.Id,0)"
                      v-if="scope.row.Status === 1"
                    >启用</el-button>
                    <el-popconfirm title="确认删除吗？" v-on:onConfirm="changeDrive(scope.row.Id,-1)" v-if="scope.row.Status!=2" >
                      <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </el-button-group>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
          <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes,jumper"
            :total="total"
            :page-size="query.PageSize"
            :page-sizes="[10,20,50]"
            :current-page.sync="query.PageIndex"
            v-on:size-change="handleSizeChange"
            v-on:current-change="handleCurrentPageChange"
          ></el-pagination>
        </div>
      </div>
      <div class="main-right">
        <div class="main-title">
          <span>
            <i class="el-icon-document"></i> 查看
          </span>
          <el-button-group>
            <el-button type="warning" v-show="flag === 1" size="mini" @click="edit">编辑</el-button>
            <el-button type="success" v-show="flag===2" size="mini" @click="save">保存</el-button>
          </el-button-group>
        </div>
        <div class="right-table">
          <table class="input-form" v-show="flag === 1" v-loading="loadingLook">
            <thead>
              <tr>
                <th colspan="2">司机信息</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>姓名</td>
                <td>{{model.detail.Name }}</td>
              </tr>
              <tr>
                <td>性别</td>
                <td>{{model.detail.Sex }}</td>
              </tr>
              <tr>
                <td>电话</td>
                <td>{{model.detail.Tel}}</td>
              </tr>
              <tr>
                <td>身份证号码</td>
                <td>{{model.detail.IdNumber}}</td>
              </tr>
              <!-- <tr>
                <td>状态</td>
                <td>{{model.detail.Status | status2Format}}</td>
              </tr> -->
              <tr>
                <td :rowspan="model.showPicList.length">司机照片</td>
                <td>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="model.pictureDialog = true"
                    v-if="model.showPicList.length > 0"
                  >查看照片</el-button>
                  <span v-else>暂无照片</span>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="input-form" v-show="flag === 2">
            <thead>
              <tr>
                <th colspan="2">司机信息</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>姓名</td>
                <td>
                  <el-input v-model="model.detail.Name"></el-input>
                </td>
              </tr>
              <tr>
                <td>性别</td>
                <td>
                  <el-select v-model="model.detail.Sex">
                    <el-option
                      v-for="item in genderMap"
                      :key="item.key"
                      :label="item.val"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </td>
              </tr>
              <tr>
                <td>电话</td>
                <td>
                  <el-input v-model="model.detail.Tel" placeholder="请选择电话"></el-input>
                </td>
              </tr>
              <tr>
                <td>身份证号码</td>
                <td>
                  <el-input v-model="model.detail.IdNumber" placeholder="请选择电话"></el-input>
                </td>
              </tr>
              <!-- <tr>
                <td>状态</td>
                <td>
                  <el-select v-model="model.detail.Status">
                    <el-option
                      v-for="item in normalStatus"
                      :key="item.key"
                      :label="item.val"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </td>
              </tr> -->
              <tr>
                <td>司机照片</td>
                <td>
                  <el-upload
                    ref="uploadEdit"
                    action="/api/co/Attachment/UploadAttachment"
                    :before-upload="uploadBefore"
                    :on-success="uploadSuccessUpdate"
                    :on-remove="uploadRemove"
                    :on-error="uploadError"
                    :file-list="model.showPicList"
                    list-type="picture"
                    :limit="1"
                    :headers="{
               AttachmentType:'scenic-pic',
                      BelongIndex: model.detail.Id,
                      sessionId: voucher.sessionId,
                      'X-Token':voucher.token,
                      }"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip">只能上传图片文件，且不超过10MB,数量为1</div>
                  </el-upload>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 展示图片 -->
        <el-dialog
          title="司机照片"
          :visible.sync="model.pictureDialog"
          width="50%"
           :close-on-click-modal="false"
          center
          class="picture-dialog"
        >
          <el-carousel indicator-position="outside" :loop="false">
            <el-carousel-item v-for="picId in model.showPicList" :key="picId.Id">
              <el-image :src="complementPicUrl(picId.Id)" fit="scale-down" style="height: 100%">
                <div slot="placeholder">加载中....</div>
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { status2Format, keyToVal, dateFormat } from "../filters/filters";
import { mapState } from "vuex";
import Attachment from "@/api/common";
import DRIVER from "../api/driver";
import { statusTypeFormat } from "../filters/filters";
export default {
  name: "DriverManage",
  inject: ["voucher", "complementPicUrl"],
  data() {
    return {
      loadintTable:false,
      loadingLook:false,
      query: {
        StartTime: "",
        EndTime: "",
        PageSize: 10,
        PageIndex: 1,
      },
      total: 0,
      tableData: [],
      options: [{ label: "大巴", value: "1" }],
      model: {
        showPicList: [],
        pictureDialog: false,
        detail: {
          Name: "",
          Sex: "",
          Tel: "",
          IdNumber: "",
          Status: "",
        },
      },
      form: {
        Id: "",
        name: "",
        sex: "",
        tel: "",
        idNumber: "",
        Status: "",
      },
      flag: 0,
      adddialogVisible: false,
      queryRules: {},
      isForbidden: true,
      fileList: [
        {
          name: "food.jpeg",
          url: "",
        },
      ],

      //添加数据
      addForm: {
        name: "",
        tel: "",
        Sex: "",
        idNumber: "",
        Images: [],
      },
      //添加验证规则
      addformrules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        tel: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        IdNumber: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
      },
    };
  },
  filters: {
    status2Format,
    statusTypeFormat,
    keyToVal,
    dateFormat,
  },
  computed: {
    ...mapState("common", ["genderMap"]),
    ...mapState("common", ["normalStatus"]),
  },
  methods: {
    //关闭弹窗后清空表单
    closeDialog(formname) {
      this.$refs[formname].clearValidate();
      this.$refs[formname].resetFields();

      this.model.showPicList = [];
    },
    //清除查询条件，重新获取
    clearQuery(formName) {
      if (formName === "queryForm") {
        this.query = {
          ProjectName: "",
          StartTime: "",
          EndTime: "",
          PageSize: 10,
          PageIndex: 1,
        };
        //this.getData();
      } else if (formName === "postForm") {
        this.model.form = {
          ProjectName: "",
          Type: "",
          Price: "",
          Address: "",
          Remarks: "",
        };
      }
      this.loadDriverList();
    },
    //添加
    postModel(formName) {
      this.$refs[formName].validate((success) => {
        if (success) {
          DRIVER.addDriver(this.addForm).then((res) => {
            if (res.status === "success") {
              this.adddialogVisible = false;
              this.$message.success("添加成功");
              this.loadDriverList();
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$message.error("请补全信息!");
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    edit() {
      this.flag = 2;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs[formName].clearValidate();
    },
    add() {
      this.adddialogVisible = true;
      this.addForm = {
        name: "",
        tel: "",
        Sex: "",
        idNumber: "",
        Images: [],
      };
    },

    //获取数据，带筛选条件
    loadDriverList() {
      this.loadintTable=true;
      DRIVER.loadDriverList(this.query).then((res) => {
        this.total = res.content.Total;
        this.tableData = res.content.OnePageData;
        this.loadintTable=false;
      });
    },
    //通过id查看
    lookDriver(Id) {
      const param = {
        Id,
      };
      this.loadingLook=true;
      DRIVER.lookDriver(param).then((res) => {
        if (res.status === "success") {
          this.model.detail = res.content.data;
          this.model.showPicList = res.content.DriverImages.map((v) => {
            let data = {
              Id: v.Id,
              name: v.FileName,
              url: this.complementPicUrl(v.Id),
            };

            return data;
          });
          this.flag = 1;
        } else {
          this.$message.error(res.msg);
        }
        this.loadingLook=false;
      });
    },
    //禁用，启用，删除
    changeDrive(Id, status) {
      switch (status) {
        case 0:
          DRIVER.enableDriver({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success(res.msg);
               this.loadDriverList();
            } else {
              this.$message.error(res.msg);
            }
          });
          break;
        case 1:
          DRIVER.disableDriver({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success(res.msg);
               this.loadDriverList();
            } else {
              this.$message.error(res.msg);
            }
          });
          break;
        case -1:
          DRIVER.deleteDriver({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success(res.msg);
               this.loadDriverList();
            } else {
              this.$message.error(res.msg);
            }
          });
          break;
        default:
          break;
      }
     
    },

    //修改保存
    save() {
      var _self=this;
      if(_self.model.detail.Sex=="男" || _self.model.detail.Sex=="女"){
        _self.model.detail.Sex=_self.model.detail.Sex=="男"?1:0;
      }
      _self.model.detail.Images = _self.model.showPicList.map((v) => v.Id);
      DRIVER.updateDriver(_self.model.detail).then((res) => {
        if (res.status === "success") {
          _self.$message.success("修改成功!");
          _self.flag = 0; //修改成功，重新获取数据，修改flag
          _self.loadDriverList();
        } else {
          _self.$message.error(res.msg);
        }
      });
      _self.loadDriverList();
    },
    handleSizeChange(val) {
      this.query.PageSize = val;
    },
    //分页  页码改变
    handleCurrentPageChange(val) {
      this.query.PageIndex = val;
    },
    //图片上传之前判断
    uploadBefore(file) {
      let fileType = file.type,
        isImage = fileType.indexOf("image") != -1,
        isBig = file.size <= 1024 * 1024 * 10;
      if (!file) {
        this.$refs.upload.onError();
        this.$message.error("上传为空！");
        return false;
      }
      if (!isImage) {
        this.$refs.upload.onError();
        this.$message.error("只能上传图片！");
        return false;
      }
      if (!isBig) {
        this.$refs.upload.onError();
        this.$message.error("图片大小不能超过10MB！");
        return false;
      }
      return true;
    },
    //图片上传成功之后回传
    uploadSuccessAdd(res) {
      if (res.status === "success") {
        this.$message.success("图片上传成功！");
        this.addForm.Images.push(res.content);
      } else {
        this.$message.error("上传失败！");
      }
    },

    uploadSuccessUpdate(res) {
      if (res.status === "success") {
        this.$message.success("图片上传成功！");
        this.model.showPicList.push({
          Id: res.content,
          url: this.complementPicUrl(res.content),
        });
      } else {
        this.$message.error("上传失败！");
      }
    },

    //图片上传失败
    uploadError() {
      this.$message.error("上传失败！");
    },
    //图片移除上传
    uploadRemoveAdd(file) {
      Attachment.deleteAttachment({
        AttachmentStatus: -1,
        AttachmentId: file.response.content,
      }).then((res) => {
        if (res.status === "success") {
          const index = this.addForm.Images.indexOf(file.response.content);
          if (index !== -1) {
            this.addForm.Images = this.addForm.Images.slice(index, 1);
          }
          this.$message.success("删除成功");
        } else {
          this.$message.error("删除失败");
        }
      });
    },
    uploadRemove(file) {
      Attachment.deleteAttachment({
        AttachmentStatus: -1,
        AttachmentId: file.Id,
      }).then((res) => {
        if (res.status === "success") {
          this.model.showPicList.pop();
          this.$message.success("删除成功");
        } else {
          this.$message.error("删除失败");
        }
      });
    },
  },
  created() {
    this.loadDriverList();
  },
  watch: {
    "query.PageSize": function () {
      this.loadDriverList();
    },
    "query.PageIndex": function () {
      this.loadDriverList();
    },
  },
};
</script>
<style scoped lang="less">
.main-left {
  width: 40%;
  border-right: 1px solid #ddd;
}
.main-left .left-table {
  height: 753px;
}
.main-left .left-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.left-pagination .pagination-bottom {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.main-right {
  flex: 1;
  min-width: 600px;
}
.right-table {
  padding: 20px;
  min-width: 700px;
}
.input-form {
  width: 50%;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.driver-manage /deep/.el-carousel__container{
  text-align: center;
}
.input-form /deep/ .el-select {
  width: 100%;
}
.input-form /deep/ .el-input__inner {
  border: none;
  width: 100%;
}
</style>
